import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9320f1b2")
const _hoisted_1 = { class: "nav-bar" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavItem = _resolveComponent("NavItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_NavItem, {
      text: "Serviços",
      to: "/services"
    }),
    _createVNode(_component_NavItem, {
      text: "Sobre mim",
      to: "/about"
    }),
    _createVNode(_component_NavItem, {
      text: "Cases",
      to: "/cases"
    }),
    _createVNode(_component_NavItem, {
      text: "Contato",
      to: "/contact"
    })
  ]))
}